import React from 'react';

import { TreadwellCarRegularIcon } from '../../../../shared/icons/icons';

import './tire-comparison-chart-bar.scss';

type PositionInBar = 'inside-bar' | 'outside-bar';

interface TireComparisonChartBarLabel {
  comparisonDistance?: number;
  distance: number;
  position: PositionInBar;
}

interface TireComparisonChartBarProps {
  className?: string;
  label?: TireComparisonChartBarLabel | null;
  showCar?: boolean;
  styleName?: string;
  width: number;
  zIndex: number;
}

function TireComparisonChartBar(props: TireComparisonChartBarProps) {
  const { className, label = null, showCar = false, width, zIndex } = props;

  return (
    <div
      className={className}
      style={{
        width: `${Math.min(100, width)}%`,
        zIndex
      }}
      styleName="container"
    >
      {showCar && <TreadwellCarRegularIcon styleName="icon" />}
      {label && (
        <span
          style={
            label.position === 'inside-bar'
              ? {
                  right: 3
                }
              : {
                  left: '100%',
                  marginLeft: 3
                }
          }
          styleName="label"
        >
          <span styleName="feet">{Math.floor(label.distance)}&rsquo;</span>
          {label.comparisonDistance && (
            <>
              <span styleName="vs">vs</span>
              <span styleName="feet">
                {Math.floor(label.comparisonDistance)}&rsquo;
              </span>
            </>
          )}
        </span>
      )}
    </div>
  );
}

export default TireComparisonChartBar;
